import 'altcha'

/**
 * Altcha has no config option for widget copy, so the shipped English locale
 * is overridden once, here, and every widget picks it up. Same wording as the
 * sister sites. Guarded because the global only exists once the browser bundle
 * has registered the element; on the server and in tests there is nothing to set.
 */
const altchaCopy = {
  label: 'Quick bot check',
  verifying: "Checking if you're a bot...",
  waitAlert: "Checking if you're a bot... hang tight.",
  verified: 'You look pretty human to me',
} as const

export function applyAltchaCopy() {
  const altcha = (
    globalThis as {
      $altcha?: { i18n: { get(l: string): object; set(l: string, v: object): void } }
    }
  ).$altcha
  if (!altcha) return false
  altcha.i18n.set('en', { ...altcha.i18n.get('en'), ...altchaCopy })
  return true
}

applyAltchaCopy()
